export default "__VITE_ASSET__CjMNHxmk__"